import type { ModalProps } from '@presentation/components/Modal/types';
import type { HTMLAttributes } from 'react';

export interface ModalCloseButtonData {
  modal: ModalProps;
}

export interface ModalCloseButtonProps
  extends HTMLAttributes<HTMLDivElement>,
    ModalCloseButtonData {}
